import React, { Fragment } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';
import { t } from 'Src/i18n';
import type { ProductChildcareAvailabilitiesProps } from 'Components/widgets/product/Product.mapper';
import { Availability } from './Availability';
import { AvailabilityAge } from './AvailabilityAge';
export const ProductChildcareAvailabilities = ({
  availableLabel,
  childcareLabel,
  items,
  monthsLabel,
  remainingLabel,
  unavailableLabel,
  unknownLabel,
  yearLabel,
  yearsLabel,
}: ProductChildcareAvailabilitiesProps) => {
  const renderConfig = {
    available: {
      color: COLORS.GREEN,
      icon: ICONS.CHECK,
      label: availableLabel,
    },
    remaining: {
      color: COLORS.ORANGE,
      icon: ICONS.WARNING,
      label: remainingLabel,
    },
    unavailable: {
      color: COLORS.RED,
      icon: ICONS.CROSS,
      label: unavailableLabel,
    },
    unknown: {
      color: COLORS.MEDIUM_GREY,
      label: unknownLabel,
    },
  };
  return (
    <Fragment>
      {items.map(({ ageMax, ageMin, availability, id, isIncluded, remainingStock, timeSlot }) => (
        <p key={id} className="mt-10 flex items-start justify-between text-14 font-bold text-black">
          <span className="flex-1">
            <AvailabilityAge
              ageMax={ageMax}
              ageMin={ageMin}
              childcareLabel={childcareLabel}
              monthsLabel={monthsLabel}
              yearLabel={yearLabel}
              yearsLabel={yearsLabel}
              timeSlot={timeSlot}
            />
            <span
              className={classnames('me-5 font-brand text-12 font-normal', {
                'text-black': isIncluded,
                'text-sienna': !isIncluded,
              })}
            >
              {isIncluded ? t('common.included') : t('common.onDemand')}
            </span>
          </span>
          <Availability
            availability={availability}
            config={renderConfig}
            remainingStock={remainingStock}
          />
        </p>
      ))}
    </Fragment>
  );
};
